import {observable, computed, action} from 'mobx';
import * as Api from 'api/api';

class Cart {
    @observable _info = null;
    @observable _list = [];
    @observable _recommendList = [];
    @observable _goodsCount = 0;
    @observable.ref _recommendPageSize = 5;
    @observable.ref _recommendPageNum = 1;
    @observable _loadingInfo = false;
    @observable _loadingRecommend = false;

    @computed get allActive() {
        for (let i in this._list) {
            if (this._list[i].active === false) {
                return false;
            }
        }

        return true;
    }

    @computed get activeCount() {
        return this.activeList.length;
    }

    @computed get activeList() {
        return this._list.filter(item => item.active);
    }

    @computed get activeTotalPrice() {
        return this._list
            .filter(item => item.active)
            .reduce((sum, item) => {
                return sum + item.goodsTotalPrice;
            }, 0);
    }

    /**
     * 获取购物车详情
     */
    @action
    async fetchInfo() {
        try {
            this.loadingInfo = true;
            const {info, list} = await Api.cartInfo();

            this._info = info;
            this._list = await Promise.all(
                list.map(async item => {
                    const {goodsId} = item;
                    let {list: skuList} = await Api.skuListByGoodsId({goodsId});
                    skuList = skuList.map(sku => {
                        const specification = sku.specificationNameAndValues
                            .map(spec => spec.name)
                            .join(',');

                        return {
                            id: sku.id,
                            goodsId: sku.goodsId,
                            specification: specification
                        };
                    });

                    return {
                        ...item,
                        active: false,
                        skuList
                    };
                })
            );
        } catch (error) {
        } finally {
            this.loadingInfo = false;
        }
    }

    /**
     * 选择商品
     * @param {*} index
     * @param {*} active
     */
    @action modifyActive(index, active) {
        this._list = this._list.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    active
                };
            } else {
                return item;
            }
        });
    }

    /**
     * （取消）全选
     * @param {*} active
     */
    @action modifyAllActive(active) {
        this._list = this._list.map(item => {
            return {
                ...item,
                active
            };
        });
    }

    /**
     * 修改商品数量
     * @param {*} cartId
     * @param {*} goodsId
     * @param {*} skuId
     * @param {*} number
     */
    @action
    async modifyGoodsCount(cartId, goodsId, skuId, number) {
        try {
            for (let key in this._list) {
                let goods = this._list[key];

                if (skuId === goods.productId) {
                    await Api.cartModifyGoodsNum({
                        goodsId,
                        skuId,
                        number,
                        cartId
                    });

                    this.fetchInfo();

                    return;
                }
            }
        } catch (error) {
        }
    }

    /**
     * 删除商品
     * @param {*} cartIdList
     */
    @action
    async deleteCart(cartIdList) {
        try {
            await Api.cartDelete({cartIdList});
            this.fetchInfo();
        } catch (error) {
        }
    }

    /**
     * 修改sku
     * @param {*} param0
     */
    @action
    async changeSku({cartId, goodsId, skuId, newSkuId, number}) {
        try {
            await Api.cartChangSku({cartId, goodsId, skuId, newSkuId, number});
            this.fetchInfo();
        } catch (error) {
        }
    }

    /**
     * 获取推荐商品
     * @param {*} param0
     */
    @action
    async fetchRecommendList({pageSize, pageNum}) {
        try {
            this.loadingRecommend = true;
            let {list} = await Api.recommendList({
                pageSize,
                pageNum
            });

            list = list.splice(0, pageSize);

            this._recommendList = list.map(item => {
                const {
                    id,
                    name,
                    originPrice,
                    currentPrice,
                    shopId,
                    soldNum,
                    mainPic,
                    hasCollect,
                    collectId,
                    categoryId,
                    isHot,
                    isNew,
                    isSpecialPrice,
                    pddShop
                } = item;

                return {
                    id,
                    name,
                    originPrice,
                    currentPrice,
                    shopId,
                    soldNum,
                    mainPic,
                    hasCollect,
                    collectId,
                    categoryId,
                    isHot,
                    isNew,
                    isSpecialPrice,
                    pddShop
                };
            });
        } catch (error) {
        } finally {
            this.loadingRecommend = false;
        }
    }

    @action
    async fetchGoodsCount() {
        try {
            const {count} = await Api.cartGoodsCount();
            this.goodsCount = count;
        } catch (error) {
        }
    }

    get info() {
        return this._info;
    }

    set info(info) {
        this._info = info;
    }

    get list() {
        return this._list;
    }

    set list(list) {
        this._list = list;
    }

    get recommendList() {
        return this._recommendList;
    }

    set recommendList(recommendList) {
        this._recommendList = recommendList;
    }

    get recommendPage() {
        return {
            size: this._recommendPageSize,
            num: this._recommendPageNum
        };
    }

    get goodsCount() {
        return this._goodsCount;
    }

    set goodsCount(value) {
        this._goodsCount = value;
    }

    get recommendPageSize() {
        return this._recommendPageSize;
    }

    set recommendPageSize(value) {
        this._recommendPageSize = value;
    }

    get recommendPageNum() {
        return this._recommendPageNum;
    }

    set recommendPageNum(value) {
        this._recommendPageNum = value;
    }

    get loadingInfo() {
        return this._loadingInfo;
    }

    set loadingInfo(value) {
        this._loadingInfo = value;
    }

    get loadingRecommend() {
        return this._loadingRecommend;
    }

    set loadingRecommend(value) {
        this._loadingRecommend = value;
    }
}

const store = new Cart();
export default store;
